// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { takeWhile } from 'rxjs';

@Component({
    selector: 'app-download-modal',
    templateUrl: './download-modal.component.html',
})
export class DownloadModalComponent implements OnDestroy {
    private isComponentAlive = true;

    constructor(
        private dialogRef: MatDialogRef<DownloadModalComponent>,
        private apiService: ApiService,
        @Inject(MAT_DIALOG_DATA) public data: { s3assetId: number }
    ) {}

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }

    cancel() {
        this.dialogRef.close();
    }

    download(): void {
        this.apiService
            .getV2$<any>(`api/file/s3Asset/${this.data.s3assetId}`)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((res) => {
                const downloadLink = document.createElement('a');
                downloadLink.href = res.data;
                downloadLink.setAttribute('download', res.data);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                this.cancel();
            });
    }
}
